var __jsx = React.createElement;
import React, { useState } from 'react';
import { useLang } from '@/common/Contexts/LanguageContext';
import { useTranslation } from "@i18n";
import Select from "@/components/UiKit/Select/Select";
import PhoneContactPopup from "./PhoneContactPopup";
var FinalCTASection = function FinalCTASection(_ref) {
  var selectedMake = _ref.selectedMake,
    selectedModel = _ref.selectedModel,
    onMakeChange = _ref.onMakeChange,
    onModelChange = _ref.onModelChange,
    onStartProcess = _ref.onStartProcess,
    carMakes = _ref.carMakes,
    carModels = _ref.carModels;
  var lang = useLang();
  var isArabic = lang === 'ar';
  var _useTranslation = useTranslation(["web_sell_trade"]),
    tShort = _useTranslation.tShort;
  var _useState = useState(false),
    isContactPopupOpen = _useState[0],
    setIsContactPopupOpen = _useState[1];
  var handleContactUsClick = function handleContactUsClick(e) {
    e.preventDefault();
    setIsContactPopupOpen(true);
  };
  var handleCloseContactPopup = function handleCloseContactPopup() {
    setIsContactPopupOpen(false);
  };
  return /*#__PURE__*/React.createElement("section", {
    className: "mt-12 md:my-[71px] px-0 md:px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-full mx-auto bg-[#F1F6FC] rounded-[16px] pt-10 pb-12 px-5 text-center md:max-w-[955px] md:py-15 md:px-10"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-[36px] font-bold text-[#3c56d4] mb-4 md:text-[28px] md:mb-3 sm:text-[24px]"
  }, tShort('final_cta/title', {
    ns: 'web_sell_trade'
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[20px] font-medium text-[#666] mb-8 md:text-[18px] md:mb-6"
  }, tShort('final_cta/subtitle', {
    ns: 'web_sell_trade'
  })), /*#__PURE__*/React.createElement("div", {
    className: "space-y-5 max-w-[566px] mx-auto mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-w-[200px] flex flex-col items-start rtl:text-end text-start"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-[16px] font-semibold text-[#555] mb-2"
  }, tShort('final_cta/make_label', {
    ns: 'web_sell_trade'
  })), /*#__PURE__*/React.createElement(Select, {
    name: "make",
    type: "select",
    className: "w-full h-12 border border-[#ddd] rounded-[6px] text-[16px] bg-white text-[#333] transition-colors duration-300 focus:border-[#3c56d4] focus:outline-none disabled:bg-[#f5f5f5] disabled:cursor-not-allowed",
    onChange: function onChange(event) {
      return onMakeChange(event.currentTarget.value);
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true,
    selected: true,
    hidden: true
  }, tShort('final_cta/make_placeholder', {
    ns: 'web_sell_trade'
  })), carMakes.map(function (make) {
    return /*#__PURE__*/React.createElement("option", {
      key: make.id,
      value: make.id.toString(),
      selected: selectedMake === make.id.toString()
    }, make.name);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-w-[200px] flex flex-col items-start rtl:text-end text-start"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-[16px] font-semibold text-[#555] mb-2"
  }, tShort('final_cta/model_label', {
    ns: 'web_sell_trade'
  })), /*#__PURE__*/React.createElement(Select, {
    name: "model",
    type: "select",
    className: "w-full h-12 border border-[#ddd] rounded-[6px] text-[16px] bg-white text-[#333] transition-colors duration-300 focus:border-[#3c56d4] focus:outline-none disabled:bg-[#f5f5f5] disabled:cursor-not-allowed",
    onChange: function onChange(event) {
      return onModelChange(event.currentTarget.value);
    },
    disabled: !selectedMake
  }, /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true,
    selected: true,
    hidden: true
  }, tShort('final_cta/model_placeholder', {
    ns: 'web_sell_trade'
  })), selectedMake && carModels[selectedMake] && carModels[selectedMake].map(function (model) {
    return /*#__PURE__*/React.createElement("option", {
      key: model.id,
      value: model.id.toString(),
      selected: selectedModel === model.id.toString()
    }, model.name);
  }))), /*#__PURE__*/React.createElement("button", {
    className: "w-full h-[52px] bg-[#fe561c] text-white text-[18px] font-bold border-none rounded-[6px] cursor-pointer transition-all duration-300 ease-in-out mt-5 hover:bg-[#e54714] hover:translate-y-[-2px] hover:shadow-[0_6px_12px_rgba(0,0,0,0.1)] md:w-[329px]",
    onClick: onStartProcess,
    "aria-label": tShort('final_cta/submit_button', {
      ns: 'web_sell_trade'
    })
  }, tShort('final_cta/submit_button', {
    ns: 'web_sell_trade'
  }))), /*#__PURE__*/React.createElement("p", {
    className: "text-[16px] text-[#3c56d4] mt-9"
  }, tShort('final_cta/need_help', {
    ns: 'web_sell_trade'
  }), " ", /*#__PURE__*/React.createElement("a", {
    href: "#contact-us",
    className: "text-[#3c56d4] font-semibold transition-colors duration-300 hover:text-[#2a45c3] underline",
    onClick: handleContactUsClick
  }, tShort('final_cta/contact_us', {
    ns: 'web_sell_trade'
  })))), /*#__PURE__*/React.createElement(PhoneContactPopup, {
    isOpen: isContactPopupOpen,
    onClose: handleCloseContactPopup
  }));
};
export default FinalCTASection;